import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import MetricCard from '../../metrics/MetricCard'

const stylePaid = (data) => (data > 0 ? { color: 'green' } : undefined)
const styleUnpaid = (data) => (data === 0 ? { color: 'green' } : { color: 'red' })

const baseMetricsDefinition = [
  { title: 'Nb factures', field: 'totalItems' },
  { title: 'Montant Factures', field: 'totalAmount', type: 'currency' },
  {
    title: 'Montant Factures Payées',
    field: 'totalAmount',
    type: 'currency',
    filter: { status: 80 },
    styleCondition: stylePaid
  },
  {
    title: 'Montant Factures Impayées',
    field: 'totalAmount',
    type: 'currency',
    filter: { status: { $ne: '80' } },
    styleCondition: styleUnpaid
  }
]

const MetricCardsList = ({ metrics, suffix = '' }) => (
  <>
    {metrics.map((metric) => (
      <MetricCard
        key={metric.title + suffix}
        title={metric.title}
        object='invoices'
        field={metric.field}
        type={metric.type}
        filter={metric.filter}
        styleCondition={metric.styleCondition}
      />
    ))}
  </>
)

const Dashboard = () => {
  const { lastPeriod, currentPeriod } = useMemo(() => {
    const dateObj = new Date()
    const month = dateObj.getUTCMonth() + 1
    const year = dateObj.getUTCFullYear()
    return {
      lastPeriod: year.toString() + (month - 1).toString().padStart(2, '0'),
      currentPeriod: year.toString() + month.toString().padStart(2, '0')
    }
  }, [])

  const baseMetrics = useMemo(() => baseMetricsDefinition, [])

  const periodsWithValues = useMemo(
    () => [
      { label: 'période précédente', period: lastPeriod },
      { label: 'période courante', period: currentPeriod }
    ],
    [lastPeriod, currentPeriod]
  )

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 65px)',
        overflowY: 'auto',
        flex: 1
      }}
    >
      <Box sx={{ mt: 1, ml: 1, display: 'flex', flexFlow: 'row wrap' }}>
        <MetricCardsList metrics={baseMetrics} />
      </Box>

      {periodsWithValues.map(({ label, period }) => {
        const metricsWithPeriod = baseMetrics.map((metric) => ({
          ...metric,
          title: `${metric.title} ${label}`,
          filter: { ...metric.filter, periodYearMonth: period }
        }))
        return (
          <Box key={period} sx={{ mt: 1, ml: 1, display: 'flex', flexFlow: 'row wrap' }}>
            <MetricCardsList metrics={metricsWithPeriod} suffix={period} />
          </Box>
        )
      })}
    </Box>
  )
}

export default Dashboard
